module.exports = __webpack_public_path__ + "static/media/ic_risk-score.9bfaa3f6.png";